import React,{useState} from 'react'
import { GroupButton } from '../../common';
import EditIcon from '../../../assets/icons/EditIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import { SidebarDrawer } from '../../common';
import VariationDeletePrompt from './VariationDeletePrompt';
import LeftNotificationPopup from '../../core/NotificationPopup/LeftNotificationPopup';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import EditVariationPrompt from './EditVariationPrompt';
import { shortenText } from '../../../utils';

const VariationCard = ({ item }:any) => {
  const [showPrompt, setShowPrompt] = useState<boolean>(false)

  const[editPrompt, setEditPrompt] = useState<boolean>(false)

  const[showSuccessfulModal, setShowSuccessfulModal] = React.useState(false);

    const handleEdit = () => {
     setEditPrompt(true)
    }

     const handleVariationDeleteSuccess = () => {
       setShowSuccessfulModal(true)
       setShowPrompt(false)
    }
   
  return (
    <>
    <div className='w-[446px] bg-[#EDF2F5] '>
        <div className='flex flex-row gap-[40px] py-[25px] px-[36px]'>
        <div className='flex flex-col'>
          <p>Variation Name</p>  
          <span className='text-[16px] text-[#000] font-bold'>{shortenText(item.variantName, 10)}</span>
        </div>
        <div className="text-[#044E97] text-[20px] md:text-[17px] lg:text-[14px] font-medium ">
              <GroupButton
                buttons={[
                  {
                    text: 'Edit',
                    icon: <EditIcon />,
                    onClick: handleEdit,
                  },
                  {
                    text: 'Delete',
                    icon: <DeleteIcon />,
                    onClick: () => {
                      setShowPrompt(true)
                    },
                  },
                ]}
              />
            </div>
        </div>
    </div>
    <SidebarDrawer 
            title={'Delete Variation'} 
            show={showPrompt} 
            position={'left'} 
            onClose={() => setShowPrompt(false)}>
            <VariationDeletePrompt 
            showPrompt={showPrompt} 
            show={() => setShowPrompt(false)}
            variationId={item.id} 
            onClose={() => setShowPrompt(false)}
            onDeleteSuccess={handleVariationDeleteSuccess}
               />
    </SidebarDrawer>

       {showSuccessfulModal && (
        <>
         <SidebarDrawer 
          title={'Variation Deleted'} 
          show={true} 
          position={'left'} 
          onClose={() => setShowSuccessfulModal(false)}>
          <LeftNotificationPopup 
          title={''}
         icon={<ProcessSuccessful/>}
         onClose={() => setShowSuccessfulModal(false)}
          />
       </SidebarDrawer>
         </>
        )}

         {editPrompt && (
          <SidebarDrawer title='Edit Your Variation' show={editPrompt} position='left'>
            <EditVariationPrompt item={item}/>
          </SidebarDrawer>
         )}
       </>

      )}

     

export default VariationCard